import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PharmacyService } from '../../../services/pharmacy/pharmacy.service';

@Component({
  selector: 'app-pharmacies',
  imports: [RouterModule],
  templateUrl: './pharmacies.html',
  styleUrl: './pharmacies.scss',
})
export class Pharmacies implements OnInit {
  private pharmacyService = inject(PharmacyService);
  hasPharmacies = signal(false);

  ngOnInit() {
    this.pharmacyService.hasAnyPharmacy().subscribe((has) => {
      this.hasPharmacies.set(has);
    });
  }
}
